
import sha256 from "js-sha256"
import authContent from "@/components/auth/authContent.vue"
import { AUTH_TYPE } from "@/constants/auth"
import { resetPassword } from "@/api/authentication"
export default {
  components: {
    authContent
  },
  data() {
    return {
      authContentType: AUTH_TYPE.FORGOT_PASSWORD
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.passwordReset")}`
    }
  },
  methods: {
    async handleResetPassword(value) {
      try {
        const response = await resetPassword({
          phone: value.phoneNumber,
          pwd: sha256(value.password),
          authCode: value.code,
          loginChannel: 3
        })
        this.$message.success(this.$t("auth.resetPasswordSuccess"))
        this.$navigation.push({
          path: "/auth/login"
        })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
